export const stationList = "STATION_LIST";
